import React, {useState} from 'react';
import {Button, Checkbox, Form, Input, Modal, Table, theme} from "antd";
import {ColumnsType} from "antd/es/table";
import {QueryKey, useQueryClient} from "@tanstack/react-query";
import {TB_STORAGEWIZ} from "./data/StorageWizMgrData";
import {useCommonUseMutation, useCommonUseQuery} from "../../../../../Common/hooks/rest/ReacQueryHook";
import {formatDate} from "../../../../../Common/util/DateUtil";
import {procAdminService} from "../../../../../Common/util/ProcService";
import {EditOutlined} from "@ant-design/icons";

const StorageRest: React.FC = () => {
    const { token: { colorBgContainer },} = theme.useToken();
    const queryClient = useQueryClient();
    const queryKey:QueryKey =   [`StorageRest`];

    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;

    const mutateUpdate = useCommonUseMutation<any>(queryKey, queryClient
        , procAdminService);

    const { data, isFetching} = useCommonUseQuery<TB_STORAGEWIZ[]>(
        queryKey,
        () =>procAdminService<TB_STORAGEWIZ[]>("post", `${serviceCode}ADS13`, null));

    const [regModal, setRegModal] = useState<boolean>(false);
    const [tbStorageWiz, setTbStorageWiz] = useState<TB_STORAGEWIZ>({
        key:'',
        isRemote:'',
        urlType:'',
        url:'',
        lastRegTime:'',
    });
    const [updateUrl, setUpdateUrl] = useState<string>();

    function onCancelModal()
    {
        setRegModal(false);
    }

    function onOpenModal( tbStorageWiz:TB_STORAGEWIZ)
    {
        setTbStorageWiz(tbStorageWiz);
        setRegModal(true);
        setUpdateUrl(tbStorageWiz.url);
    }

    function onChageUpdateUrl(e:any)
    {
        setUpdateUrl(e.target.value);
    }

    function onSaveUrl()
    {
        const request:TB_STORAGEWIZ  = {
            key : tbStorageWiz.key,
            isRemote:tbStorageWiz.isRemote,
            urlType:tbStorageWiz.urlType,
            url:updateUrl as string,
            lastRegTime:tbStorageWiz.lastRegTime,
        }
        const updateParam = { method: 'post', serviceCode: `${serviceCode}ADU03`, requestBody:request }
        mutateUpdate.mutateAsync(updateParam)
            .catch(error => {
                console.error(error);

            }).finally(() => {
        });
        setRegModal(false);
    }

    const columns: ColumnsType<TB_STORAGEWIZ> = [
        {
            title: '원격여부',
            dataIndex: 'isRemote',
            key: 'isRemote',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Checkbox checked={text === '1' ? true : false}/>
                </div>
            ,
        },
        {
            title: 'URL 기능',
            dataIndex: 'urlType',
            key: 'urlType',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text.toUpperCase()}
                </div>
            ,
        },
        {
            title: 'StorageWiz 경로',
            dataIndex: 'url',
            key: 'url',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'left', justifyContent: 'left' }}>
                    {text}
                </div>
            ,
        },
        {
            title: '생성일자',
            key: 'lastRegTime',
            dataIndex: 'lastRegTime',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>
            ,
        },
        {
            title: '',
            key: 'Active',
            dataIndex: 'Active',
            render: (text, record:TB_STORAGEWIZ) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button type="link" size="small" onClick={() => {onOpenModal(record)}}>URL 변경</Button>
                </div>
            ,
        },

    ];

    const fields = [
        { name: ['updateUrl'], value: updateUrl },
    ];

    return (
        <>
        <Table columns={columns}
               dataSource={data}
               rowKey="key"
               loading={isFetching}
        />

            <Modal
                open={regModal}
                title="통신 URL변경"
                onCancel={onCancelModal}
                footer={[
                    <></>
                ]}
            >
                <Form
                    fields={fields}
                    name="saveBatch"
                    initialValues={{
                        remember: false,
                    }}
                    onFinish={onSaveUrl}
                >
                    <Form.Item
                        label={"URL"}
                        name="updateUrl"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="URL"
                            defaultValue={updateUrl}
                            value={updateUrl}
                            onChange={onChageUpdateUrl}
                        />

                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button">
                            적용
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default StorageRest;
